import React from 'react';
import styled from 'styled-components/macro';
import { fmt } from '../../utils/fmtUtils';

const EstadisticasRankingPartidosTabla_FilaCampo = props => {
  return (
    <FilaCampos >
      <CampoTitulo>{props.title}</CampoTitulo>
      <Campo>{fmt(props.data.vot.act)} ({props.data.pvot.act})</Campo>
      <Campo>{fmt(props.data.vot.ant)} ({props.data.pvot.ant})</Campo>
      <Campo>{fmt(props.data.vot.antant)} ({props.data.pvot.antant})</Campo>
    </FilaCampos>
  );
};

const FilaCampos = styled.tr`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #dadada;
`;
const Campo = styled.th`
  width: 20%;
  text-align: right;
  // border: 1px solid red;
`;

const CampoTitulo = styled.th`
  width: 40%;
  text-align: left;
  // border: 1px solid red;
`;

export default EstadisticasRankingPartidosTabla_FilaCampo;
